import { TextButton } from '@creditornot/cb-button';
import { cssThemedValue } from '@creditornot/cb-ingredients';
import { MenuItemGroup, MenuCheckboxItem } from '@creditornot/cb-menu';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

export type GenericColumn = {
  value: string;
  label: string;
  defaultChecked?: boolean;
  disabled?: boolean;
};

type ColumnSelectorProps = {
  options: GenericColumn[];
  variant?: 'black' | 'blue';
  selectedColumns: GenericColumn[];
  onChange: (selectedColumns: GenericColumn[]) => void;
  onSelectAll: () => void;
  onDeselectAll: () => void;
  actionsPlacement?: 'top' | 'bottom';
};

const Content = styled.div`
  min-width: 180px;
`;

const ItemContent = styled.div`
  max-height: 328px;
  overflow-y: auto;
  padding: 8px 16px;
`;

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px 16px;
  border-block-start: 1px solid ${cssThemedValue('borderPrimary')};
`;

export const ColumnSelector = ({
  options,
  selectedColumns,
  onChange,
  onSelectAll,
  onDeselectAll,
  actionsPlacement = 'bottom',
}: ColumnSelectorProps) => {
  const intl = useIntl();
  return (
    <Content>
      {actionsPlacement === 'top' && (
        <Actions>
          <TextButton variant="blue" onClick={onDeselectAll}>
            <FormattedMessage id="shared-menu.editor.importer.table-view.deselect-all" />
          </TextButton>
          <TextButton variant="blue" onClick={onSelectAll}>
            <FormattedMessage id="shared-menu.editor.importer.table-view.select-all" />
          </TextButton>
        </Actions>
      )}
      <ItemContent>
        <MenuItemGroup>
          {options.map(option => (
            <MenuCheckboxItem
              key={option.value}
              disabled={!!option.disabled}
              checked={!!selectedColumns?.find(({ value }) => value === option.value)}
              onClick={() => {
                if (!selectedColumns) {
                  return undefined;
                }
                return !!selectedColumns.find(({ value }) => value === option.value)
                  ? onChange(selectedColumns?.filter(({ value }) => value !== option.value))
                  : onChange([...selectedColumns, option]);
              }}
            >
              {intl.formatMessage({ id: option.label })}
            </MenuCheckboxItem>
          ))}
        </MenuItemGroup>
      </ItemContent>
      {actionsPlacement === 'bottom' && (
        <Actions>
          <TextButton variant="blue" onClick={onDeselectAll}>
            <FormattedMessage id="shared-menu.editor.importer.table-view.deselect-all" />
          </TextButton>
          <TextButton variant="blue" onClick={onSelectAll}>
            <FormattedMessage id="shared-menu.editor.importer.table-view.select-all" />
          </TextButton>
        </Actions>
      )}
    </Content>
  );
};
